import { Component } from '@angular/core'
import { reviewTabs } from '../../models/reviews.enum'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { ReviewsService } from '../../services/reviews.service'
import { reviewsModel } from '../../models/reviews.models'

@Component({
	selector: 'app-reviews-list',
	templateUrl: './reviews-list.component.html',
	styleUrl: './reviews-list.component.scss',
})
export class ReviewsListComponent {
	subscription = new Subscription()
	countryId: number = 224
	reviewTabs = this.SharedService.returnEnumArray(reviewTabs)
	reviewFilter = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		activeTab: 1,
		countryId: 224,
	}
	reviews: reviewsModel[] = []
	totalCount: number = 0
	pendingCount: number = 0
	constructor(
		private SharedService: SharedService,
		private router: Router,
		private ActivatedRoute: ActivatedRoute,
		private ReviewsService: ReviewsService
	) {}
	ngOnInit() {
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.reviewFilter.activeTab = res['activeTab'] || 1
				this.reviewFilter.countryId = res['countryId'] || 224
				this.reviewFilter.paging.pageNumber = res['page'] || 1
				this.reviewFilter.paging.pageSize = res['count'] || 10

				this.SharedService.handleBreadCrumb('reviews', true, {
					name: '',
					id: '',
					url: '/layout/reviews',
					queryParams: { ...res },
				})

				this.getAllReviews()
				this.getPendingCount()
			})
		)
		this.SharedService.headerTitle.next('BREADCRUMB.REVIEWS')
	}
	getAllReviews() {
		this.ReviewsService.getAllReviews(this.reviewFilter).subscribe(
			(res: any) => {
				this.reviews = res?.result?.items
				this.totalCount = res?.result?.totalCount
			}
		)
	}
	getPendingCount() {
		let body = { ...this.reviewFilter }
		body.activeTab = 1
		this.ReviewsService.getPendingCount(body).subscribe((res: any) => {
			let pending = this.reviewTabs.find((val) => val.value == '1')

			pending
				? ((pending.count = res.result.pendingCount),
				  (pending.showCount = res.result.pendingCount ? true : false))
				: null
		})
	}
	changeStatus(event: any) {
		event.countryId = this.reviewFilter.countryId

		this.ReviewsService.changeReviewStatus(event).subscribe(() => {
			this.getAllReviews()
			this.getPendingCount()
		})
	}
	urlParamsChange(event: number, paramName: string) {
		this.router.navigate(['/layout/reviews'], {
			queryParams: {
				[paramName]: event,
			},
			queryParamsHandling: 'merge',
		})
	}
	pageChanged(pageNumber: number, pageCount: number) {
		console.log(pageNumber)

		this.router.navigate(['/layout/reviews'], {
			queryParams: {
				page: pageNumber,
				count: pageCount,
			},
			queryParamsHandling: 'merge',
		})
	}
}
